/**
 * File: /Users/tomasmuniesa/Documents/develop/nousmedis/nm-apps/3_catalog_cloud/develop/frontend/src/app/modules/catalog-cloud/resolvers/fascicle.resolver copy.ts
 * Project: /Users/tomasmuniesa/Documents/develop/nousmedis/nm-apps/3_catalog_cloud/develop/frontend
 * Created Date: Monday, December 16th 2024, 3:47:42 pm
 * Author: Tomás
 * -----
 * Last Modified:  Monday, 16th December 2024 5:11:41 pm
 * Modified By: Tomás (tomas@cege.es>)
 * -----
 * Copyright (c) 2024 Nousmedis, CeGe
 * ------------------------------------
 */


import { inject, Injectable } from '@angular/core';
import {
  ResolveFn
} from '@angular/router';
import { PageTemplateService } from '../services/page-template.service';

export const PageTemplateResolver: ResolveFn<any> = async (route, state) => {

  const pageTemplateService = inject(PageTemplateService);

  try {
    const breadcrumbs = await pageTemplateService.getBreadCrumbPageTemplateList();
    return breadcrumbs;
  } catch (error) {
    console.error('Error en el Resolver:', error);
    return []; // Manejo de errores: devuelve un array vacío o un valor por defecto
  }
};